const routes = [
    {
        path: "/",
        name: "/",
        redirect: "/signin",
    },
    {
        path: "/signin",
        name: "Signin",
        component: () => import('@/modules/auth/views/LoginView.vue'),
    },
    {
        path: "/signup",
        name: "Signup",
        component: () => import('@/modules/auth/views/RegistroView.vue'),
    },
];

export default routes;